import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';
import { HttpClientModule } from '@angular/common/http';

import { RepairGroupComponent } from './repair-group/repair-group.component';
import { BulletinTypeComponent } from './bulletin-type/bulletin-type.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { VehicleBrandComponent } from './vehicle-brand/vehicle-brand.component';
import { RoleComponent } from './role/role.component';
import { ParamComponent } from './param/param.component';
import { MailComponent } from './mail/mail.component';

@NgModule({
    declarations: [
        VehicleComponent,
        RepairGroupComponent,
        BulletinTypeComponent,
        VehicleBrandComponent,
        RoleComponent,
        ParamComponent,
        MailComponent
    ],
    exports: [
        VehicleComponent,
        RepairGroupComponent,
        BulletinTypeComponent,
        VehicleBrandComponent,
        RoleComponent,
        ParamComponent,
        MailComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        DialogModule,
        MessageModule,
        MessagesModule,
        HttpClientModule,
        DropdownModule,
        InputNumberModule,
        KeyFilterModule
    ]
})
export class MastersModule {

}